// extracted by mini-css-extract-plugin
export default {"Paragraph":"Verification_Paragraph__nH5uX","CancelContainer":"Verification_CancelContainer__aLMY0"};